export default __webpack_public_path__ + "static/media/File No. 23.6c2dd93d.pdf";